(() => {
  const SPEC_ORDER = ['size', 'pit-to-pit', 'length', 'art', 'colour', 'condition'];
  const SPEC_LABELS = {
    size: 'Size',
    'pit-to-pit': 'Pit to pit',
    length: 'Length',
    art: 'ART',
    colour: 'Colour',
    condition: 'Condition',
  };

  const normaliseKey = (label) => {
    const value = label.trim().toLowerCase().replace(/\s+/g, ' ');
    if (value === 'size') return 'size';
    if (value === 'pit to pit' || value === 'pit-to-pit' || value === 'p2p') return 'pit-to-pit';
    if (value === 'length') return 'length';
    if (value === 'art' || value === 'art.' || value === 'article') return 'art';
    if (value === 'colour' || value === 'color') return 'colour';
    if (value === 'condition') return 'condition';
    return '';
  };

  const extractNaturalCondition = (line) => {
    const match = line.match(/\bin\s+([^.!?]*?\bcondition)\s*(?:([.!?])(?=\s|$)|$)/i);
    if (!match) return null;

    const condition = match[1].trim();
    const before = line.slice(0, match.index).trimEnd();
    const after = line.slice(match.index + match[0].length).trimStart();
    let remaining = [before, after].filter(Boolean).join(' ');

    if (before && !after && match[2] && !/[.!?]$/.test(remaining)) {
      remaining += match[2];
    }

    return {
      condition: condition.charAt(0).toUpperCase() + condition.slice(1),
      remaining,
    };
  };

  const extractSpecs = (copy) => {
    const values = new Map();

    copy.querySelectorAll('p').forEach((paragraph) => {
      const lines = paragraph.textContent
        .split(/\n+/)
        .map((line) => line.trim())
        .filter(Boolean);
      const remaining = [];

      lines.forEach((line) => {
        const naturalCondition = extractNaturalCondition(line);
        if (naturalCondition) {
          values.set('condition', naturalCondition.condition);
          if (naturalCondition.remaining) remaining.push(naturalCondition.remaining);
          return;
        }

        const match = line.match(/^([^:]{2,24}):\s*(.+)$/);
        const key = match ? normaliseKey(match[1]) : '';
        if (key && match[2].trim()) {
          values.set(key, match[2].trim());
        } else {
          remaining.push(line);
        }
      });

      if (remaining.length === 0 && lines.length > 0) {
        paragraph.remove();
      } else if (remaining.length !== lines.length) {
        paragraph.textContent = remaining.join(' ');
      }
    });

    return values;
  };

  const createRow = (key, value) => {
    const row = document.createElement('div');
    row.className = 'dd-dossier-spec';
    row.dataset.ddSpecKey = key;

    const term = document.createElement('dt');
    term.textContent = SPEC_LABELS[key];
    const detail = document.createElement('dd');
    detail.textContent = value;

    row.append(term, detail);
    return row;
  };

  const extractSeason = (title) => {
    const match = title.match(/(?:^|\s)((?:S\/S|A\/W|F\/W|P\/S)\s*(?:19|20)?\d{2})(?=\s|$)/i);
    return match ? match[1].toUpperCase().replace(/\s+/g, ' ') : '';
  };

  const combineColour = (descriptionColour, variantColour) => {
    const descriptionValue = descriptionColour.trim();
    const variantValue = variantColour.trim();
    if (!descriptionValue || !variantValue) return descriptionValue || variantValue;

    const descriptionNormalised = descriptionValue.toLowerCase();
    const variantNormalised = variantValue.toLowerCase();
    if (descriptionNormalised === variantNormalised || descriptionNormalised.includes(variantNormalised)) {
      return descriptionValue;
    }

    return `${descriptionValue} - ${variantValue}`;
  };

  const updateKicker = (section, values) => {
    const kicker = section.querySelector('[data-dd-dossier-kicker]');
    if (!kicker) return;

    const brand = kicker.dataset.ddBrand.trim();
    const season = extractSeason(kicker.dataset.ddProductTitle || '');
    const art = values.get('art') || kicker.dataset.ddProductSku.trim();
    const entries = [brand, season, art ? `ART. ${art}` : ''].filter(Boolean);

    kicker.replaceChildren();
    entries.forEach((entry) => {
      const item = document.createElement('span');
      item.textContent = entry;
      kicker.append(item);
    });
  };

  const initialiseDossier = (root = document) => {
    root.querySelectorAll('.dd-product-dossier').forEach((section) => {
      const specs = section.querySelector('[data-dd-dossier-specs]');
      const copies = Array.from(section.querySelectorAll('[data-dd-description-copy]'));
      if (section.dataset.ddDossierReady === 'true') return;

      const extracted = copies.length > 0 ? extractSpecs(copies[0]) : new Map();
      copies.slice(1).forEach((copy) => extractSpecs(copy));

      const values = new Map();
      if (specs) {
        specs.querySelectorAll('[data-dd-spec-key]').forEach((row) => {
          const key = row.dataset.ddSpecKey;
          const detail = row.querySelector('dd');
          if (key && detail && detail.textContent.trim()) values.set(key, detail.textContent.trim());
        });
      }
      const variantColour = values.get('colour') || '';
      extracted.forEach((value, key) => values.set(key, value));
      if (extracted.has('colour') && variantColour) {
        values.set('colour', combineColour(extracted.get('colour'), variantColour));
      }

      if (specs) {
        specs.replaceChildren();
        SPEC_ORDER.forEach((key) => {
          const value = values.get(key);
          if (value) specs.append(createRow(key, value));
        });
      }

      updateKicker(section, values);

      section.dataset.ddDossierReady = 'true';
    });
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-dd-enquiry-link]');
    if (!link) return;

    const selector = link.getAttribute('href');
    if (!selector || !selector.startsWith('#')) return;

    const enquiry = document.querySelector(selector);
    if (!enquiry) return;

    event.preventDefault();
    enquiry.open = true;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    requestAnimationFrame(() => {
      enquiry.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseDossier());
  } else {
    initialiseDossier();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseDossier(event.target));
})();
